import PropTypes from "prop-types";

import { Button, Section, Text } from "components/ui/source";
import { leisureStandards } from "components/ui/source/components/SonderStandards/content";

import styles from "./Intro.module.scss";

function Features({ amenities, standards, showAmenities }) {
  const amenitiesElements =
    amenities
      ?.filter(amenity => amenity.active)
      .slice(0, Math.min(4, amenities.length))
      .map(amenity => (
        <Text
          className={styles.feature_tag}
          types={["caption2"]}
          key={amenity.name}
        >
          {amenity.label}
        </Text>
      )) || [];

  const standardsElement =
    standards
      ?.slice(0, Math.min(4, standards.length))
      .map(standard => (
        <Text
          className={styles.feature_tag}
          types={["caption2"]}
          key={standard}
          translateKey={leisureStandards[standard].translateKey}
        />
      )) || [];

  return (
    <Section className={styles.features_container}>
      {standardsElement.length > 0 && (
        <div className={styles.features}>
          <Text
            className={styles.feature_title}
            types={["caption1", "medium"]}
            translateKey="listing:intro.standards"
          />
          {standardsElement}
        </div>
      )}
      {amenitiesElements.length > 0 && (
        <div className={styles.features}>
          <Text
            className={styles.feature_title}
            types={["caption1", "medium"]}
            translateKey="listing:intro.amenities"
          />
          {amenitiesElements}
        </div>
      )}
      <Button
        className={styles.seeAll}
        type="no_background"
        textProps={{
          types: ["caption1", "underline"],
          translateKey: "listing:intro.seeAllAmenities",
        }}
        centered={false}
        onClick={showAmenities}
        upperCase={false}
      />
    </Section>
  );
}

Features.propTypes = {
  amenities: PropTypes.arrayOf(PropTypes.object),
  standards: PropTypes.arrayOf(PropTypes.string),
  showAmenities: PropTypes.func,
};

Features.defaultProps = {
  amenities: [],
  standards: ["checkIn", "cleaning", "wifi", "support"],
  showAmenities: () => {},
};

export default Features;
